import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  background-color: rgba(243, 245, 248, 1);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 16px;
`;

export const SectionContainer = styled.div`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 8px;
  margin: 0px 8px 8px 8px;
  padding: 16px 24px;
`;

export const Divider = styled.div`
  border-bottom: 1px solid rgba(228, 231, 236, 1);
  margin: 16px 0px;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding: 22px 24px;
`;

export const ItemRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ItemKey = styled.div`
  color: rgba(49, 57, 74, 1);
  font-size: 14px;
  font-weight: 300;
`;

export const ItemValue = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 16px;
  font-weight: 400;
`;

export const LabeledAmountCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 46px;
`;

export const LabeledAmountTitle = styled.div`
  color: rgba(49, 57, 74, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 12px;
  gap: 7px;

  & svg {
    margin-bottom: 2px;
  }
`;

export const LabeledAmountValue = styled.div<{ isBold?: boolean }>`
  color: ${PRIMARY_BLACK};
  font-size: ${({ isBold }) => (isBold ? 24 : 20)}px;
  font-weight: ${({ isBold }) => (isBold ? 700 : 400)};
`;

export const CellMathSymbol = styled.div`
  color: rgba(74, 84, 102, 1);
  display: flex;
  align-items: flex-end;
  height: 44px;
  padding-bottom: 4px;
`;
